import { render, staticRenderFns } from "./TeachingMaterialCatogoriesPage.vue?vue&type=template&id=8c102932&"
import script from "./TeachingMaterialCatogoriesPage.vue?vue&type=script&lang=ts&"
export * from "./TeachingMaterialCatogoriesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSpacer,VTextField,VTooltip})
